// Uclean-Admin-Dashboard/src/mocks/promo/promotionGroups/handlers.js

import { http, HttpResponse } from 'msw';
import { BASE } from '../_shared/base';
import { engineError } from '../_shared/errors';
import { makeUuid } from '../_shared/ids';
import { groupsStore } from './store';
import { promotionsStore } from '../promotions/store';

const ROOT = `${BASE}/promotion-groups`;

export const promotionGroupsHandlers = [
  // GET list — plain {data: [...]}, no pagination per doc
  http.get(ROOT, () => HttpResponse.json({ data: groupsStore })),

  http.post(ROOT, async ({ request }) => {
    const body = await request.json();
    const row = { id: makeUuid(), ...body };
    groupsStore.push(row);
    return HttpResponse.json({ data: row }, { status: 201 });
  }),

  http.patch(`${ROOT}/:id`, async ({ params, request }) => {
    const body = await request.json();
    const idx = groupsStore.findIndex((g) => g.id === params.id);
    if (idx === -1) return new HttpResponse(null, { status: 404 });
    groupsStore[idx] = { ...groupsStore[idx], ...body };
    return HttpResponse.json({ data: groupsStore[idx] });
  }),

  // DELETE — hard delete; 409 if any non-inactive promo references the group
  http.delete(`${ROOT}/:id`, ({ params }) => {
    const referencing = promotionsStore.filter((p) =>
      p.group_id === params.id && p.status !== 'inactive');
    if (referencing.length > 0) {
      return engineError('group_in_use', {
        status: 409,
        message: `Used by ${referencing.length} promotion(s)`,
        count: referencing.length,
      });
    }
    const idx = groupsStore.findIndex((g) => g.id === params.id);
    if (idx === -1) return new HttpResponse(null, { status: 404 });
    groupsStore.splice(idx, 1);
    return HttpResponse.json({ data: { deleted: params.id } });
  }),
];
